import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <section className="flex min-h-[55vh] flex-col items-start justify-center">
      <p className="text-sm font-semibold uppercase tracking-[0.24em] text-stone-500 dark:text-stone-400">
        404
      </p>
      <h1 className="font-display mt-4 text-4xl tracking-tight text-stone-900 dark:text-stone-100 sm:text-5xl">
        That page doesn't exist.
      </h1>
      <p className="mt-4 max-w-xl text-lg leading-8 text-stone-600 dark:text-stone-300">
        The link may be outdated, or the page may have moved during the site
        rebuild.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex rounded-full bg-stone-900 px-5 py-3 text-sm font-medium text-stone-50 transition hover:bg-stone-700 dark:bg-stone-100 dark:text-stone-900 dark:hover:bg-stone-300"
      >
        Back to home
      </Link>
    </section>
  );
};

export default NotFound;
